import type { PdfViewerToolbarProps } from "./pdf-viewer-toolbar.type";

import {
  LeftOutlined,
  RightOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";
import { Button, Divider, Flex, Space } from "antd";
import { useTranslation } from "react-i18next";
import { TfiTarget } from "react-icons/tfi";

import { handleToolbarEvent } from "./pdf-viewer-toolbar.helper";

import "./pdf-viewer-toolbar.style.less";

export const PdfViewerToolbar = ({
  page,
  pagesCount,
  zoom,
  zoomMax,
  zoomMin,
  onPreviousPage,
  onNextPage,
  onZoomDecrease,
  onZoomIncrease,
  showPagination = true,
  showZoom = true,
  showGoToHighlightPage = true,
  disableHighlightPage = false,
  onGoToHighlightPage,
}: PdfViewerToolbarProps) => {
  const { t } = useTranslation();

  const handleZoomDecrease = (event: React.MouseEvent<HTMLElement>) =>
    handleToolbarEvent(event, onZoomDecrease);

  const handleZoomIncrease = (event: React.MouseEvent<HTMLElement>) =>
    handleToolbarEvent(event, onZoomIncrease);

  const handlePreviousPage = (event: React.MouseEvent<HTMLElement>) =>
    handleToolbarEvent(event, onPreviousPage);

  const handleNextPage = (event: React.MouseEvent<HTMLElement>) =>
    handleToolbarEvent(event, onNextPage);

  const handleGoToHighLightPage = (event: React.MouseEvent<HTMLElement>) =>
    handleToolbarEvent(event, onGoToHighlightPage);

  return (
    <Flex gap="small" align="center" className="pdf-toolbar">
      <Space
        separator={<Divider orientation="vertical" />}
        className="pdf-toolbar-inner"
      >
        {showZoom && (
          <Space>
            <Button
              shape="circle"
              size="small"
              title={t("global:documentViewer.zoomOut")}
              icon={<ZoomOutOutlined />}
              onClick={handleZoomDecrease}
              disabled={zoom <= zoomMin}
            />
            {`${Math.round(zoom * 100)}%`}
            <Button
              shape="circle"
              size="small"
              title={t("global:documentViewer.zoomIn")}
              icon={<ZoomInOutlined />}
              onClick={handleZoomIncrease}
              disabled={zoom >= zoomMax}
            />
          </Space>
        )}

        {showPagination && (
          <Space>
            <Button
              shape="circle"
              size="small"
              title={t("global:documentViewer.previousPage")}
              onClick={handlePreviousPage}
              disabled={page === 1}
            >
              <LeftOutlined />
            </Button>
            {`${page}/${pagesCount}`}
            <Button
              shape="circle"
              size="small"
              title={t("global:documentViewer.nextPage")}
              onClick={handleNextPage}
              disabled={page === pagesCount}
            >
              <RightOutlined />
            </Button>
          </Space>
        )}
        {showGoToHighlightPage && (
          <Button
            shape="circle"
            size="small"
            title={t("global:documentViewer.backToHighlightPage.observation")}
            onClick={handleGoToHighLightPage}
            disabled={disableHighlightPage}
          >
            <TfiTarget />
          </Button>
        )}
      </Space>
    </Flex>
  );
};
